import type { GridMap } from "../generation/GridMap";
import { CELL_SIZE, type Point } from "../generation/types";

export interface WorldPoint {
  readonly x: number;
  readonly z: number;
}

export function gridToWorld(point: Point, grid: GridMap): WorldPoint {
  return {
    x: (point.x - grid.width / 2 + 0.5) * CELL_SIZE,
    z: (point.y - grid.height / 2 + 0.5) * CELL_SIZE,
  };
}

export function worldToGrid(x: number, z: number, grid: GridMap): Point {
  return {
    x: Math.floor(x / CELL_SIZE + grid.width / 2),
    y: Math.floor(z / CELL_SIZE + grid.height / 2),
  };
}
